// Maps a raw HIGO "encounter" payload (higoEncounterId, reports[]) into the
// shapes the app already consumes elsewhere: numeric measurements (like a
// Vitals WS event's `measurements`) and visual-media groups (like repeated
// VisualMediaReady WS events), grouped/deduped by measurementType.
export const mapHigoEncounterToVitalsPayloads = (encounter) => {
  const reports = encounter?.reports || [];

  const measurements = reports.flatMap((report) =>
    (report.valueMeasurements || []).map((m) => ({
      measurementType: m.type,
      value: m.value,
      unit: m.unit,
      textValue: m.textValue,
    }))
  );

  const visualMediaByType = new Map();
  reports.forEach((report) => {
    (report.visualMeasurements || []).forEach((vm) => {
      const files = (vm.sourceFiles || [])
        .slice()
        .sort((a, b) => (a.sequenceOrder ?? 0) - (b.sequenceOrder ?? 0))
        .map((f) => ({ id: f.id, fileUrl: f.fileUrl, contentType: f.contentType, createdAt: f.createdAt }));

      const existing = visualMediaByType.get(vm.measurementType);
      if (existing) {
        existing.files.push(...files);
      } else {
        visualMediaByType.set(vm.measurementType, {
          measurementType: vm.measurementType,
          visualMeasurementId: vm.id,
          timestamp: vm.measurementDateTime,
          files,
        });
      }
    });
  });

  return {
    measurements,
    visualMediaGroups: Array.from(visualMediaByType.values()),
  };
};
